import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faEdit, faTrash, faEllipsis, faCheckCircle, faExclamationCircle, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../../DashBaord/Top_navbar";

import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import { list,changeStatus,deleteBanner} from "../../../../controllers/V1/cms/pickupPointsDataController";
import { getPage, formatProjectDate } from "../../../../controllers/common";

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {

  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'seq_id'?{seq_id : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'mobile'?{page : parseInt(filter?.search) }:null),
          ...(filter?.filter_by === 'name'?{name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'address'?{address : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'status'?{status : filter?.search }:null),
          ...(filter?.from?{createdAt : {$gte : new Date(`${filter.from} 0:00:00`), $lte : new Date(`${filter.from} 23:59:00`)} }:null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    setLimit(10);
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "Crown King || Pickup Point's list";
  }, [currentPage, showRequest, filter]);

  const handleEdit = (items) => {
    navigate('/cms/pickup-point/addeditdata', { state: items });
  }

  const handleDelete = async (id = '') =>{
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Id not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else {
        const option ={ id : id };
        const res = await deleteBanner(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Delete successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Error while procession`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  }

  const handleChangeStatus = async (id = '', status = '') =>{
    try {
      if(!id){
        notification.open({
          message: "Oops!",
          description: `Data not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else if(!status){
        notification.open({
          message: "Oops!",
          description: `Status not pass.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      } else {
        const option ={ id : id, status : status };
        const res = await changeStatus(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Updated successfully..`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else {
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
    } catch (error) {
      notification.open({
        message: "Oops!",
        description: `Error while procession`,
        placement: "topRight",
        icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
        duration: 2,
      });
    }
  }

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Pickup Point's list"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div" onClick={handleFiterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>

                  <div onClick={() => navigate('/cms/pickup-point/addeditdata')}>
                    <button type="button" class="btn btn-dark">
                      <span className="request_new_categories">Add New</span>
                    </button>
                  </div>
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellspacing="0"
                        >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Seq Id</th>
                              <th>Name</th>
                              <th>Mobile</th>
                              <th>Address</th>
                              <th>Created Date & Time</th>
                              <th>Seq. Order</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index} >
                                    <td>{SKIP + index + 1}</td>
                                    <td>{items?.seq_id}</td>
                                    <td>{items?.name}</td>
                                    <td>{items?.mobile}</td>
                                    <td>{items?.address}</td>
                                    
                                    <td>{moment(formatProjectDate(items?.createdAt)).format('DD-MM-YYYY h:mm A')}</td>
                                    <td>{items?.seq_order}</td>
                                    <td>{items?.status}</td>
                                    <td>
                                      <Dropdown
                                        placement="bottomLeft"
                                        arrow
                                        overlay={
                                          <Menu>
                                            <Menu.Item key={`1`} onClick={() => { handleEdit(items) }} >
                                              <FontAwesomeIcon icon={faEdit} /> <span className="show_span">Edit</span>
                                            </Menu.Item>
                                            {(items.status === 'I') && (
                                              <Menu.Item key={`2`} onClick={()=>handleChangeStatus(items._id,'A') } >
                                                <FontAwesomeIcon icon={faThumbsUp} /> <span className="show_span">Active</span>
                                              </Menu.Item>
                                            )}
                                            {items.status === 'A' && (
                                              <Menu.Item key={`3`} onClick={() => handleChangeStatus(items._id,'I')} >
                                                <FontAwesomeIcon icon={faThumbsDown} /> <span className="show_span">Inactive</span>
                                              </Menu.Item>
                                            )}
                                            {items.status !== 'D' && (<>
                                              <Menu.Item key={`4`} onClick={() => handleDelete(items._id)} >
                                                <FontAwesomeIcon icon={faTrash} /> <span className="show_span">Delete</span>
                                              </Menu.Item>
                                            </>)}
                                     
                                          </Menu>
                                        }
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    </td>
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={5} col={9} /> : <tr> 
                                <td colspan="9" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'var(--brand-red)', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value='' selected disabled>Select search field</option>
                  <option value='seq_id' selected={filter?.filter_by ==='seq_id'?true:false}>Seq Id</option>
                  <option value='name' selected={filter?.filter_by ==='name'?true:false}>Name</option>
                  <option value='mobile' selected={filter?.filter_by ==='mobile'?true:false}>Mobile</option>
                  <option value='address' selected={filter?.filter_by ==='address'?true:false}>Address</option>
                   </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  From :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="from_date"
                  className="form-control store_input_field"
                  id="from_date"      
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="date"
                  name="to_date"
                  className="form-control store_input_field"
                  id="to_date"   
                  ref={inputRef4}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "var(--brand-red-dark)", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
